export default "__VITE_ASSET__CUP7n6b$__"